import { injectBaseConstantMethods } from "./BaseConstants"

const ConfiguratorOrderStatus = {
   Save: "SAVE",
   Deposit: "DEPOSIT",
   Complete: "COMPLETE",
}

const displayTextKeys = {
   [ConfiguratorOrderStatus.Save]: "Saved",
   [ConfiguratorOrderStatus.Deposit]: "Deposited",
   [ConfiguratorOrderStatus.Complete]: "Completed",
}

const labelClass = {
   [ConfiguratorOrderStatus.Save]: "configurator-order-save",
   [ConfiguratorOrderStatus.Deposit]: "configurator-order-deposit",
   [ConfiguratorOrderStatus.Complete]: "configurator-order-complete",
}

export default injectBaseConstantMethods(
   ConfiguratorOrderStatus,
   displayTextKeys,
   labelClass
)
